/**
 * Franny Ant Design 5 ThemeConfig
 * Implements the design language in docs/design/DESIGN.md
 * (Artificial Analysis data backbone + Mercury fintech polish, dark-blue core; SETTLED chat palette (pages/main)).
 *
 * Swap this into src/themes/index.ts to apply the new look.
 * Requires Inter + IBM Plex Mono loaded (e.g. via index.html Google Fonts link)
 * and an optional Source Serif 4 for editorial hero headlines.
 */
import type { ThemeConfig } from "antd";

const frannyTheme: ThemeConfig = {
  token: {
    // --- Colors (from DESIGN.md) ---
    colorPrimary: "#1f2a5c", // interaction core — Franny dark blue
    colorInfo: "#1f2a5c",
    colorSuccess: "#2f6b46",
    colorWarning: "#f9b500",
    colorError: "#8e1f2f", // danger — Franny deep red
    colorTextBase: "#000000", // ink
    colorBgBase: "#ffffff",
    colorBgLayout: "#f4f5f7", // light-gray page background (chat palette)
    colorBgContainer: "#ffffff", // raised surfaces (cards)
    colorBgElevated: "#ffffff",
    colorBorder: "#e3e5e9", // hairline
    colorBorderSecondary: "#f0eee6",
    // --- Radius ---
    borderRadius: 8, // sm
    borderRadiusLG: 16, // lg
    borderRadiusSM: 8,
    // --- Typography (DESIGN.md) ---
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontFamilyCode: "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeHeading1: 40,
    fontSizeHeading2: 32,
    fontSizeHeading3: 24,
    lineHeightHeading1: 1.1,
    lineHeightHeading2: 1.15,
    lineHeightHeading3: 1.25,
    // --- Elevation (flat, subtle) ---
    boxShadow: "0 1px 2px rgba(16,16,26,0.06)",
    boxShadowSecondary: "0 4px 12px rgba(16,16,26,0.08)",
    boxShadowTertiary: "0 12px 32px rgba(16,16,26,0.12)",
    // --- Spacing (4px baseline) ---
    controlHeight: 40,
    controlHeightLG: 48,
    padding: 16,
    paddingLG: 24,
    paddingMD: 16,
    marginLG: 24,
    marginXL: 32,
  },
  components: {
    Card: {
      borderRadiusLG: 16,
      colorBorderSecondary: "#f0eee6",
      paddingLG: 24,
    },
    Layout: {
      colorBgBody: "#f5f5f2",
      colorBgHeader: "#ffffff",
      // headerText: "#000000",
    },
    Menu: {
      colorItemBg: "transparent",
      colorItemText: "#6b7280",
      colorItemTextSelected: "#1f2a5c",
      colorItemBgSelected: "transparent",
      activeBarBorderWidth: 0,
      itemSelectedBg: "transparent",
    },
    Typography: {
      colorText: "#000000",
      colorTextDescription: "#6b7280",
    },
  },
};

export default frannyTheme;
